const calculateMass = ({ width, height, length }) => {
  const mass = (width * height * length) / 6000;
  const value = isNaN(mass) ? 0 : mass;

  return Math.round(value * 100) / 100;
};

export default calculateMass;
